// React Query hooks for /settings/theme.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import { useToast } from '../../../hooks/useToast';
import type { CompanyTheme } from '../../../types/api';

export function useThemePickerQuery() {
  return useQuery<CompanyTheme>({
    queryKey: queryKeys.company.theme,
    queryFn: async () => {
      const res = await apiClient.get<CompanyTheme>(endpoints.company.theme);
      return res.data;
    },
    staleTime: 60_000,
  });
}

export function useSaveTheme() {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: async (theme: Record<string, string>) => {
      const res = await apiClient.put<CompanyTheme, Record<string, string>>(
        endpoints.company.theme,
        theme,
      );
      return res.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.company.theme });
      toast.success('Theme saved.');
    },
    onError: () => {
      toast.error('Failed to save theme.');
    },
  });
}
